import { render } from "./reload.vue?vue&type=template&id=86d53a08"
import script from "./reload.vue?vue&type=script&lang=js"
export * from "./reload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__